import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { I18nModule, UrlModule } from '@spartacus/core';
import { IconModule } from '@spartacus/storefront';
import { UigStatusCellComponent } from './uig-status-cell/uig-status-cell.component';
import { UigUserCellComponent } from './uig-user-cell/uig-user-cell.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    UrlModule,
    I18nModule,
    IconModule
  ],
  declarations: [
    UigStatusCellComponent,
    UigUserCellComponent
  ],
})
export class UigCellModule { }
